import { useState, useLayoutEffect } from "react";
import { getInstantForms } from "@/API/repositories/instantForm";
import { useRequestsContext } from "@/common/hooks/requestHook";
import { useMessageQueueContext } from "@/common/hooks/useMessageQueue";
import { handleFormatResponse } from "../helpers";
import { ERROR_RESPONSE_TEXT } from "../constants/index.js";

export const useInstantForms = () => {
    const [instantFormsData, setInstantFormsData] = useState([]);
    const [forms, setForms] = useState({ active: [], unactive: [] });
    const [showNew, setShowNew] = useState(false);
    const [isActiveDisplayed, setIsActiveDisplayed] = useState(true);
    const [isUnactiveDisplayed, setIsUnactiveDisplayed] = useState(false);

    const { hasUnfilledRequest, makeRequest } = useRequestsContext();
    const { addMessage } = useMessageQueueContext();

    const handleGetInstantForms = async () => {

        const response = await makeRequest(getInstantForms.bind(null));

        if (response?.data) {
            setInstantFormsData(response.data);

            const formatedResponse = handleFormatResponse(response);
            setForms(formatedResponse);
        }

        if (!response?.data) {
            addMessage(ERROR_RESPONSE_TEXT, 'error');
        }
    };


    useLayoutEffect(() => {
        if (!showNew) {
            handleGetInstantForms();
        }
    }, [showNew]);

    return {
        isLoading: hasUnfilledRequest(getInstantForms),
        isActiveDisplayed, setIsActiveDisplayed,
        isUnactiveDisplayed, setIsUnactiveDisplayed,
        instantFormsData,
        forms, setForms,
        showNew, setShowNew,
    };
};
